import React, { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers";
import Icon from "@mdi/react";
import { mdiLightSwitch, mdiLightSwitchOff } from "@mdi/js";
import { dispatch } from "../../App";
import { actions } from "../../redux";

import "./Header.scss";

const Header = () => {

    const [darkMode, setDarkMode] = useState<boolean>(true);


    useSelector((state: RootState) => {
        if (state.system.themeDark !== darkMode) {
            setDarkMode(state.system.themeDark);
        }
    });


    const toggleSwitch = () => {
        dispatch(actions.system.toggleDarkTheme());
    }

    const getSwitch = () => {
        if (!darkMode) {
            return <Icon path={mdiLightSwitchOff} size={1} />
        }

        return <Icon path={mdiLightSwitch} size={1} />
    };


    return (
        <div className="header">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-auto">
                    <img className="badCode" src="/bad-code-head.png" alt="logo" />
                </div>
                <div className="col"></div>
                <div className="col-auto">
                </div>
                <div className="col-auto"><span className="switch" onClick={toggleSwitch}>{getSwitch()}</span></div>
                <div className="col-auto"></div>
            </div>
        </div>
    </div>    
    );
}

export { Header };
